import React, { useState, useEffect } from 'react';
import '../../styles/auth.css';
import { ApplicantRegistrationT, currentLanguage } from '../../services/LanguageTranslationService';
import { DivisionDistrictTalukaTranslation } from '../../language/DivisionDistrictTalukaTranslation';
import ReCAPTCHA from 'react-google-recaptcha';

const Registration = ({ onClose, onSwitchToLogin }) => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    email: '',
    mobile: '',
    address: '',
    district: '',
    taluka: '',
    village: '',
    password: '',
    confirmPassword: ''
  });

  // Maharashtra location data with district and taluka
  const locationData = [
    { district: "Ahilyanagar", taluka: "Ahilyanagar" },
    { district: "Ahilyanagar", taluka: "Akole" },
    { district: "Ahilyanagar", taluka: "Jamkhed" },
    { district: "Ahilyanagar", taluka: "Karjat" },
    { district: "Ahilyanagar", taluka: "Kopargaon" },
    { district: "Ahilyanagar", taluka: "Nevasa" },
    { district: "Ahilyanagar", taluka: "Parner" },
    { district: "Ahilyanagar", taluka: "Pathardi" },
    { district: "Ahilyanagar", taluka: "Rahta" },
    { district: "Ahilyanagar", taluka: "Rahuri" },
    { district: "Ahilyanagar", taluka: "Sangamner" },
    { district: "Ahilyanagar", taluka: "Shevgaon" },
    { district: "Ahilyanagar", taluka: "Shrigonda" },
    { district: "Ahilyanagar", taluka: "Shrirampur" },

    //akola
    { district: "Akola", taluka: "Akola" },
    { district: "Akola", taluka: "Akot" },
    { district: "Akola", taluka: "Balapur" },
    { district: "Akola", taluka: "Barshitakli" },
    { district: "Akola", taluka: "Murtijapur" },
    { district: "Akola", taluka: "Patur" },
    { district: "Akola", taluka: "Telhara" },
    //amravati
    { district: "Amravati", taluka: "Achalpur" },
    { district: "Amravati", taluka: "Amravati" },
    { district: "Amravati", taluka: "Anjangaon Surji" },
    { district: "Amravati", taluka: "Bhatkuli" },
    { district: "Amravati", taluka: "Chandur Railway" },
    { district: "Amravati", taluka: "Chandurbazar" },
    { district: "Amravati", taluka: "Chikhaldara" },
    { district: "Amravati", taluka: "Daryapur" },
    { district: "Amravati", taluka: "Dhamangaon Railway" },
    { district: "Amravati", taluka: "Dharni" },
    { district: "Amravati", taluka: "Morshi" },
    { district: "Amravati", taluka: "Nandgaon-Khandeshwar" },
    { district: "Amravati", taluka: "Tiosa" },
    { district: "Amravati", taluka: "Warud" },
    //beed
    { district: "Beed", taluka: "Ambejogai" },
    { district: "Beed", taluka: "Ashti" },
    { district: "Beed", taluka: "Beed" },
    { district: "Beed", taluka: "Dharur" },
    { district: "Beed", taluka: "Georai" },
    { district: "Beed", taluka: "Kaij" },
    { district: "Beed", taluka: "Majalgaon" },
    { district: "Beed", taluka: "Parli" },
    { district: "Beed", taluka: "Patoda" },
    { district: "Beed", taluka: "Shirur (Kasar)" },
    { district: "Beed", taluka: "Wadwani" },

    { district: "Bhandara", taluka: "Bhandara" },
    { district: "Bhandara", taluka: "Lakhandur" },
    { district: "Bhandara", taluka: "Lakhani" },
    { district: "Bhandara", taluka: "Mohadi" },
    { district: "Bhandara", taluka: "Pauni" },
    { district: "Bhandara", taluka: "Sakoli" },
    { district: "Bhandara", taluka: "Tumsar" },

    //buldhana
    { district: "Buldhana", taluka: "Buldana" },
    { district: "Buldhana", taluka: "Chikhli" },
    { district: "Buldhana", taluka: "Deolgaon Raja" },
    { district: "Buldhana", taluka: "Jalgaon (Jamod)" },
    { district: "Buldhana", taluka: "Khamgaon" },
    { district: "Buldhana", taluka: "Lonar" },
    { district: "Buldhana", taluka: "Malkapur" },
    { district: "Buldhana", taluka: "Mehkar" },
    { district: "Buldhana", taluka: "Motala" },
    { district: "Buldhana", taluka: "Nandura" },
    { district: "Buldhana", taluka: "Sangrampur" },
    { district: "Buldhana", taluka: "Shegaon" },
    { district: "Buldhana", taluka: "Sindkhed Raja" },

    { district: "Chandrapur", taluka: "Ballarpur" },
    { district: "Chandrapur", taluka: "Bhadravati" },
    { district: "Chandrapur", taluka: "Brahmapuri" },
    { district: "Chandrapur", taluka: "Chandrapur" },
    { district: "Chandrapur", taluka: "Chimur" },
    { district: "Chandrapur", taluka: "Gondpipri" },
    { district: "Chandrapur", taluka: "Jiwati" },
    { district: "Chandrapur", taluka: "Korpana" },
    { district: "Chandrapur", taluka: "Mul" },
    { district: "Chandrapur", taluka: "Nagbhid" },
    { district: "Chandrapur", taluka: "Pombhurna" },
    { district: "Chandrapur", taluka: "Rajura" },
    { district: "Chandrapur", taluka: "Sawali" },
    { district: "Chandrapur", taluka: "Sindewahi" },
    { district: "Chandrapur", taluka: "Warora" },

    //chhatrapati sambhaji nagar
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Chhatrapati Sambhaji Nagar" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Gangapur" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Kannad" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Khuldabad" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Paithan" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Phulambri" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Sillod" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Soegaon" },
    { district: "Chhatrapati Sambhaji Nagar", taluka: "Vaijapur" },

    // dharashiv
    { district: "Dharashiv", taluka: "Bhum" },
    { district: "Dharashiv", taluka: "Dharashiv" },
    { district: "Dharashiv", taluka: "Kalamb" },
    { district: "Dharashiv", taluka: "Lohara" },
    { district: "Dharashiv", taluka: "Omarga" },
    { district: "Dharashiv", taluka: "Paranda" },
    { district: "Dharashiv", taluka: "Tuljapur" },
    { district: "Dharashiv", taluka: "Washi" },

    { district: "Dhule", taluka: "Dhule" },
    { district: "Dhule", taluka: "Sakri" },
    { district: "Dhule", taluka: "Shirpur" },
    { district: "Dhule", taluka: "Sindkhede" },

    { district: "Gadchiroli", taluka: "Aheri" },
    { district: "Gadchiroli", taluka: "Armori" },
    { district: "Gadchiroli", taluka: "Bhamragad" },
    { district: "Gadchiroli", taluka: "Chamorshi" },
    { district: "Gadchiroli", taluka: "Desaiganj (Vadasa)" },
    { district: "Gadchiroli", taluka: "Dhanora" },
    { district: "Gadchiroli", taluka: "Etapalli" },
    { district: "Gadchiroli", taluka: "Gadchiroli" },
    { district: "Gadchiroli", taluka: "Korchi" },
    { district: "Gadchiroli", taluka: "Kurkheda" },
    { district: "Gadchiroli", taluka: "Mulchera" },
    { district: "Gadchiroli", taluka: "Sironcha" },

    { district: "Gondia", taluka: "Amgaon" },
    { district: "Gondia", taluka: "Arjuni Morgaon" },
    { district: "Gondia", taluka: "Deori" },
    { district: "Gondia", taluka: "Gondiya" },
    { district: "Gondia", taluka: "Goregaon" },
    { district: "Gondia", taluka: "Sadak-Arjuni" },
    { district: "Gondia", taluka: "Salekasa" },
    { district: "Gondia", taluka: "Tirora" },

    // hingoli
    { district: "Hingoli", taluka: "Aundha (Nagnath)" },
    { district: "Hingoli", taluka: "Hingoli" },
    { district: "Hingoli", taluka: "Kalamnuri" },
    { district: "Hingoli", taluka: "Sengaon" },
    { district: "Hingoli", taluka: "Vasmath" },

    { district: "Jalgaon", taluka: "Amalner" },
    { district: "Jalgaon", taluka: "Bhadgaon" },
    { district: "Jalgaon", taluka: "Bhusawal" },
    { district: "Jalgaon", taluka: "Bodvad" },
    { district: "Jalgaon", taluka: "Chalisgaon" },
    { district: "Jalgaon", taluka: "Chopda" },
    { district: "Jalgaon", taluka: "Dharangaon" },
    { district: "Jalgaon", taluka: "Erandol" },
    { district: "Jalgaon", taluka: "Jalgaon" },
    { district: "Jalgaon", taluka: "Jamner" },
    { district: "Jalgaon", taluka: "Muktainagar (Edlabad)" },
    { district: "Jalgaon", taluka: "Pachora" },
    { district: "Jalgaon", taluka: "Parola" },
    { district: "Jalgaon", taluka: "Raver" },
    { district: "Jalgaon", taluka: "Yawal" },

    //jalna
    { district: "Jalna", taluka: "Ambad" },
    { district: "Jalna", taluka: "Badnapur" },
    { district: "Jalna", taluka: "Bhokardan" },
    { district: "Jalna", taluka: "Ghansawangi" },
    { district: "Jalna", taluka: "Jafrabad" },
    { district: "Jalna", taluka: "Jalna" },
    { district: "Jalna", taluka: "Mantha" },
    { district: "Jalna", taluka: "Partur" },

    { district: "Kolhapur", taluka: "Ajra" },
    { district: "Kolhapur", taluka: "Bhudargad" },
    { district: "Kolhapur", taluka: "Chandgad" },
    { district: "Kolhapur", taluka: "Gadhinglaj" },
    { district: "Kolhapur", taluka: "Gaganbawada" },
    { district: "Kolhapur", taluka: "Hatkanangle" },
    { district: "Kolhapur", taluka: "Kagal" },
    { district: "Kolhapur", taluka: "Karvir" },
    { district: "Kolhapur", taluka: "Panhala" },
    { district: "Kolhapur", taluka: "Radhanagari" },
    { district: "Kolhapur", taluka: "Shahuwadi" },
    { district: "Kolhapur", taluka: "Shirol" },

    //latur
    { district: "Latur", taluka: "Ahmadpur" },
    { district: "Latur", taluka: "Ausa" },
    { district: "Latur", taluka: "Chakur" },
    { district: "Latur", taluka: "Deoni" },
    { district: "Latur", taluka: "Jalkot" },
    { district: "Latur", taluka: "Latur" },
    { district: "Latur", taluka: "Nilanga" },
    { district: "Latur", taluka: "Renapur" },
    { district: "Latur", taluka: "Shirur Anantpal" },
    { district: "Latur", taluka: "Udgir" },

    { district: "Nagpur", taluka: "Bhiwapur" },
    { district: "Nagpur", taluka: "Hingna" },
    { district: "Nagpur", taluka: "Kalameshwar" },
    { district: "Nagpur", taluka: "Kamptee" },
    { district: "Nagpur", taluka: "Katol" },
    { district: "Nagpur", taluka: "Kuhi" },
    { district: "Nagpur", taluka: "Mauda" },
    { district: "Nagpur", taluka: "Nagpur (Rural)" },
    { district: "Nagpur", taluka: "Nagpur (Urban)" },
    { district: "Nagpur", taluka: "Narkhed" },
    { district: "Nagpur", taluka: "Parseoni" },
    { district: "Nagpur", taluka: "Ramtek" },
    { district: "Nagpur", taluka: "Savner" },
    { district: "Nagpur", taluka: "Umred" },

    // nanded
    { district: "Nanded", taluka: "Ardhapur" },
    { district: "Nanded", taluka: "Bhokar" },
    { district: "Nanded", taluka: "Biloli" },
    { district: "Nanded", taluka: "Deglur" },
    { district: "Nanded", taluka: "Dharmabad" },
    { district: "Nanded", taluka: "Hadgaon" },
    { district: "Nanded", taluka: "Himayatnagar" },
    { district: "Nanded", taluka: "Kandhar" },
    { district: "Nanded", taluka: "Kinwat" },
    { district: "Nanded", taluka: "Loha" },
    { district: "Nanded", taluka: "Mahur" },
    { district: "Nanded", taluka: "Mudkhed" },
    { district: "Nanded", taluka: "Mukhed" },
    { district: "Nanded", taluka: "Naigaon (Khairgaon)" },
    { district: "Nanded", taluka: "Nanded" },
    { district: "Nanded", taluka: "Umri" },

    { district: "Nandurbar", taluka: "Akkalkuwa" },
    { district: "Nandurbar", taluka: "Akrani" },
    { district: "Nandurbar", taluka: "Nandurbar" },
    { district: "Nandurbar", taluka: "Nawapur" },
    { district: "Nandurbar", taluka: "Shahade" },
    { district: "Nandurbar", taluka: "Talode" },

    { district: "Nashik", taluka: "Baglan" },
    { district: "Nashik", taluka: "Chandvad" },
    { district: "Nashik", taluka: "Deola" },
    { district: "Nashik", taluka: "Dindori" },
    { district: "Nashik", taluka: "Igatpuri" },
    { district: "Nashik", taluka: "Kalwan" },
    { district: "Nashik", taluka: "Malegaon" },
    { district: "Nashik", taluka: "Nandgaon" },
    { district: "Nashik", taluka: "Nashik" },
    { district: "Nashik", taluka: "Niphad" },
    { district: "Nashik", taluka: "Peth" },
    { district: "Nashik", taluka: "Sinnar" },
    { district: "Nashik", taluka: "Surgana" },
    { district: "Nashik", taluka: "Trimbakeshwar" },
    { district: "Nashik", taluka: "Yevla" },

    // palghar
    { district: "Palghar", taluka: "Dahanu" },
    { district: "Palghar", taluka: "Jawhar" },
    { district: "Palghar", taluka: "Mokhada" },
    { district: "Palghar", taluka: "Palghar" },
    { district: "Palghar", taluka: "Talasari" },
    { district: "Palghar", taluka: "Vasai" },
    { district: "Palghar", taluka: "Vikramgad" },
    { district: "Palghar", taluka: "Wada" },
    //parbhani
    { district: "Parbhani", taluka: "Gangakhed" },
    { district: "Parbhani", taluka: "Jintur" },
    { district: "Parbhani", taluka: "Manwath" },
    { district: "Parbhani", taluka: "Palam" },
    { district: "Parbhani", taluka: "Parbhani" },
    { district: "Parbhani", taluka: "Pathri" },
    { district: "Parbhani", taluka: "Purna" },
    { district: "Parbhani", taluka: "Selu" },
    { district: "Parbhani", taluka: "Sonpeth" },
    //pune
    { district: "Pune", taluka: "Ambegaon" },
    { district: "Pune", taluka: "Baramati" },
    { district: "Pune", taluka: "Bhor" },
    { district: "Pune", taluka: "Daund" },
    { district: "Pune", taluka: "Haveli" },
    { district: "Pune", taluka: "Indapur" },
    { district: "Pune", taluka: "Junnar" },
    { district: "Pune", taluka: "Khed" },
    { district: "Pune", taluka: "Mawal" },
    { district: "Pune", taluka: "Mulshi" },
    { district: "Pune", taluka: "Pune City" },
    { district: "Pune", taluka: "Purandhar" },
    { district: "Pune", taluka: "Shirur" },
    { district: "Pune", taluka: "Velhe" },
    //Raigad
    { district: "Raigad", taluka: "Alibag" },
    { district: "Raigad", taluka: "Karjat" },
    { district: "Raigad", taluka: "Khalapur" },
    { district: "Raigad", taluka: "Mahad" },
    { district: "Raigad", taluka: "Mangaon" },
    { district: "Raigad", taluka: "Mhasla" },
    { district: "Raigad", taluka: "Murud" },
    { district: "Raigad", taluka: "Panvel" },
    { district: "Raigad", taluka: "Pen" },
    { district: "Raigad", taluka: "Poladpur" },
    { district: "Raigad", taluka: "Roha" },
    { district: "Raigad", taluka: "Shrivardhan" },
    { district: "Raigad", taluka: "Sudhagad" },
    { district: "Raigad", taluka: "Tala" },
    { district: "Raigad", taluka: "Uran" },

    { district: "Ratnagiri", taluka: "Chiplun" },
    { district: "Ratnagiri", taluka: "Dapoli" },
    { district: "Ratnagiri", taluka: "Guhagar" },
    { district: "Ratnagiri", taluka: "Khed" },
    { district: "Ratnagiri", taluka: "Lanja" },
    { district: "Ratnagiri", taluka: "Mandangad" },
    { district: "Ratnagiri", taluka: "Rajapur" },
    { district: "Ratnagiri", taluka: "Ratnagiri" },
    { district: "Ratnagiri", taluka: "Sangameshwar" },

    { district: "Sangli", taluka: "Atpadi" },
    { district: "Sangli", taluka: "Jat" },
    { district: "Sangli", taluka: "Kadegaon" },
    { district: "Sangli", taluka: "Kavathemahankal" },
    { district: "Sangli", taluka: "Khanapur" },
    { district: "Sangli", taluka: "Miraj" },
    { district: "Sangli", taluka: "Palus" },
    { district: "Sangli", taluka: "Shirala" },
    { district: "Sangli", taluka: "Tasgaon" },
    { district: "Sangli", taluka: "Walwa" },

    { district: "Satara", taluka: "Jaoli" },
    { district: "Satara", taluka: "Karad" },
    { district: "Satara", taluka: "Khandala" },
    { district: "Satara", taluka: "Khatav" },
    { district: "Satara", taluka: "Koregaon" },
    { district: "Satara", taluka: "Mahabaleshwar" },
    { district: "Satara", taluka: "Man" },
    { district: "Satara", taluka: "Patan" },
    { district: "Satara", taluka: "Phaltan" },
    { district: "Satara", taluka: "Satara" },
    { district: "Satara", taluka: "Wai" },

    { district: "Sindhudurg", taluka: "Devgad" },
    { district: "Sindhudurg", taluka: "Dodamarg" },
    { district: "Sindhudurg", taluka: "Kankavli" },
    { district: "Sindhudurg", taluka: "Kudal" },
    { district: "Sindhudurg", taluka: "Malwan" },
    { district: "Sindhudurg", taluka: "Sawantwadi" },
    { district: "Sindhudurg", taluka: "Vaibhavvadi" },
    { district: "Sindhudurg", taluka: "Vengurla" },

    { district: "Solapur", taluka: "Akkalkot" },
    { district: "Solapur", taluka: "Barshi" },
    { district: "Solapur", taluka: "Karmala" },
    { district: "Solapur", taluka: "Madha" },
    { district: "Solapur", taluka: "Malshiras" },
    { district: "Solapur", taluka: "Mangalvedhe" },
    { district: "Solapur", taluka: "Mohol" },
    { district: "Solapur", taluka: "Pandharpur" },
    { district: "Solapur", taluka: "Sangole" },
    { district: "Solapur", taluka: "Solapur North" },
    { district: "Solapur", taluka: "Solapur South" },

    { district: "Thane", taluka: "Ambarnath" },
    { district: "Thane", taluka: "Bhiwandi" },
    { district: "Thane", taluka: "Kalyan" },
    { district: "Thane", taluka: "Murbad" },
    { district: "Thane", taluka: "Shahapur" },
    { district: "Thane", taluka: "Thane" },
    { district: "Thane", taluka: "Ulhasnagar" },

    { district: "Wardha", taluka: "Arvi" },
    { district: "Wardha", taluka: "Ashti" },
    { district: "Wardha", taluka: "Deoli" },
    { district: "Wardha", taluka: "Hinganghat" },
    { district: "Wardha", taluka: "Karanja" },
    { district: "Wardha", taluka: "Samudrapur" },
    { district: "Wardha", taluka: "Seloo" },
    { district: "Wardha", taluka: "Wardha" },

    // washim
    { district: "Washim", taluka: "Karanja" },
    { district: "Washim", taluka: "Malegaon" },
    { district: "Washim", taluka: "Mangrulpir" },
    { district: "Washim", taluka: "Manora" },
    { district: "Washim", taluka: "Risod" },
    { district: "Washim", taluka: "Washim" },
    // yavatmal
    { district: "Yavatmal", taluka: "Arni" },
    { district: "Yavatmal", taluka: "Babulgaon" },
    { district: "Yavatmal", taluka: "Darwha" },
    { district: "Yavatmal", taluka: "Digras" },
    { district: "Yavatmal", taluka: "Ghatanji" },
    { district: "Yavatmal", taluka: "Kalamb" },
    { district: "Yavatmal", taluka: "Kelapur" },
    { district: "Yavatmal", taluka: "Mahagaon" },
    { district: "Yavatmal", taluka: "Maregaon" },
    { district: "Yavatmal", taluka: "Ner" },
    { district: "Yavatmal", taluka: "Pusad" },
    { district: "Yavatmal", taluka: "Ralegaon" },
    { district: "Yavatmal", taluka: "Umarkhed" },
    { district: "Yavatmal", taluka: "Wani" },
    { district: "Yavatmal", taluka: "Yavatmal" },
    { district: "Yavatmal", taluka: "Zari-Jamani" },


  ];

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    console.log("Captcha value:", value);
  };

  // Function to get translated location name
  const getTranslatedLocationName = (type, name) => {
    return DivisionDistrictTalukaTranslation[currentLanguage][type]?.[name] || name;
  };
  // Get unique districts
  const districts = [...new Set(locationData.map(item => item.district))];

  // Get talukas for selected district
  const getTalukas = (district) => {
    if (!district) return [];
    return locationData
      .filter(item => item.district === district)
      .map(item => item.taluka);
  };

  const [talukas, setTalukas] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [apiResponse, setApiResponse] = useState({
    show: false,
    message: '',
    isSuccess: false
  });

  // Update talukas when district changes
  useEffect(() => {
    if (formData.district) {
      const filteredTalukas = getTalukas(formData.district);
      setTalukas(filteredTalukas);
      // Reset taluka when district changes
      setFormData(prev => ({ ...prev, taluka: '' }));
    } else {
      setTalukas([]);
    }
  }, [formData.district]);

  // ESC key handler
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape' && !isLoading && !apiResponse.show) onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose, isLoading, apiResponse]);

  // Password strength calculator
  useEffect(() => {
    if (!formData.password) {
      setPasswordStrength(0);
      return;
    }

    let strength = 0;
    if (formData.password.length >= 8) strength += 1;
    if (/\d/.test(formData.password)) strength += 1;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(formData.password)) strength += 1;
    if (/[a-z]/.test(formData.password) && /[A-Z]/.test(formData.password)) strength += 1;

    setPasswordStrength(strength);
  }, [formData.password]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // For mobile number, only allow numbers
    if (name === 'mobile') {
      if (!/^\d*$/.test(value)) return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = ApplicantRegistrationT('registration.errors.firstNameRequired');
    //if (!formData.lastName.trim()) newErrors.lastName = ApplicantRegistrationT('registration.errors.lastNameRequired');
    //if (!formData.gender) newErrors.gender = ApplicantRegistrationT('registration.errors.genderRequired');

    if (!formData.email.trim()) {
      newErrors.email = ApplicantRegistrationT('registration.errors.emailRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = ApplicantRegistrationT('registration.errors.validEmail');
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = ApplicantRegistrationT('registration.errors.mobileRequired');
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = ApplicantRegistrationT('registration.errors.mobileDigits');
    }

    if (!formData.address.trim()) newErrors.address = ApplicantRegistrationT('registration.errors.addressRequired');
    if (!formData.district) newErrors.district = ApplicantRegistrationT('registration.errors.selectDistrict');
    if (!formData.taluka) newErrors.taluka = ApplicantRegistrationT('registration.errors.selectTaluka');
    if (!formData.village) newErrors.village = ApplicantRegistrationT('registration.errors.enterVillage');

    if (!formData.password) {
      newErrors.password = ApplicantRegistrationT('registration.errors.passwordRequired');
    } else if (formData.password.length < 8) {
      newErrors.password = ApplicantRegistrationT('registration.errors.passwordLength');
    } else if (passwordStrength < 2) {
      newErrors.password = ApplicantRegistrationT('registration.errors.passwordWeak');
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = ApplicantRegistrationT('registration.errors.confirmPassword');
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = ApplicantRegistrationT('registration.errors.passwordMismatch');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    if (!captchaValue) {
      alert('Please complete the CAPTCHA');
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/register_applicant.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || ApplicantRegistrationT('registration.errors.registrationFailed'));
      }

      if (result.status === "success") {
        setApiResponse({
          show: true,
          message: result.message || ApplicantRegistrationT('registration.successMessage'),
          isSuccess: true
        });
        // Clear form on successful registration
        handleReset();
      } else {
        throw new Error(result.message || ApplicantRegistrationT('registration.errors.registrationIncomplete'));
      }
    } catch (error) {
      setApiResponse({
        show: true,
        message: error.message,
        isSuccess: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      firstName: '',
      middleName: '',
      lastName: '',
      gender: '',
      email: '',
      mobile: '',
      address: '',
      district: '',
      taluka: '',
      village: '',
      password: '',
      confirmPassword: ''
    });
    setErrors({});
    setTalukas([]);
  };

  const closeResponseModal = () => {
    setApiResponse({ ...apiResponse, show: false });
    if (apiResponse.isSuccess) {
      onSwitchToLogin();
    }
  };

  return (
    <div className="auth-container" onClick={(e) => e.target === e.currentTarget && !isLoading && !apiResponse.show && onClose()}>
      {/* Response Modal */}
      {apiResponse.show && (
        <div className="response-modal-overlay">
          <div className="response-modal">
            <div className={`response-modal-content ${apiResponse.isSuccess ? 'success' : 'error'}`}>
              <div className="response-modal-icon">
                {apiResponse.isSuccess ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                )}
              </div>
              <h3>{apiResponse.isSuccess ? ApplicantRegistrationT('registration.success') : ApplicantRegistrationT('registration.error')}</h3>
              <p>{apiResponse.message}</p>
              <button
                onClick={closeResponseModal}
                className={`response-modal-button ${apiResponse.isSuccess ? 'success' : 'error'}`}
              >
                {apiResponse.isSuccess ? ApplicantRegistrationT('registration.proceedToLogin') : ApplicantRegistrationT('registration.tryAgain')}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="auth-box registration-box">
        <div className="auth-header">
          <div className="info-icon-container">
            <button
              className="info-icon-button"
              onClick={() => setShowInstructions(true)}
              type="button"
              aria-label={ApplicantRegistrationT('registration.showInstructions')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
              </svg>
            </button>
          </div>
          <h2 className="auth-title">{ApplicantRegistrationT('registration.title')}</h2>
          <div className="auth-tabs">
            <button
              className="auth-tab"
              onClick={onSwitchToLogin}
              type="button"
              disabled={isLoading}
            >
              {ApplicantRegistrationT('registration.login')}
            </button>
            <button
              className="auth-tab active"
              disabled={isLoading}
            >
              {ApplicantRegistrationT('registration.register')}
            </button>
          </div>
          <button
            className="close-button"
            onClick={onClose}
            aria-label={ApplicantRegistrationT('registration.closeForm')}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-sections-container">
            {/* Personal Information Section */}
            <div className="form-section">
              <h3 className="section-title">{ApplicantRegistrationT('registration.personalInfo')}</h3>
              <div className="form-row">
                <div className={`form-group ${errors.firstName ? 'error' : ''}`}>
                  <label htmlFor="firstName">{ApplicantRegistrationT('registration.firstName')}*</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.firstNamePlaceholder')}
                    disabled={isLoading}
                  />
                  {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="middleName">{ApplicantRegistrationT('registration.middleName')}</label>
                  <input
                    type="text"
                    id="middleName"
                    name="middleName"
                    value={formData.middleName}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.middleNamePlaceholder')}
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.lastName ? 'error' : ''}`}>
                  <label htmlFor="lastName">{ApplicantRegistrationT('registration.lastName')}</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.lastNamePlaceholder')}
                    disabled={isLoading}
                  />
                  {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                </div>

                <div className={`form-group ${errors.gender ? 'error' : ''}`}>
                  <label htmlFor="gender">{ApplicantRegistrationT('registration.gender')}</label>
                  <select
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    disabled={isLoading}
                  >
                    <option value="">{ApplicantRegistrationT('registration.selectGender')}</option>
                    <option value="Female">{ApplicantRegistrationT('registration.genderFemale')}</option>
                    <option value="Male">{ApplicantRegistrationT('registration.genderMale')}</option>
                    <option value="Other">{ApplicantRegistrationT('registration.genderOther')}</option>
                  </select>
                  {errors.gender && <span className="error-message">{errors.gender}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.email ? 'error' : ''}`}>
                  <label htmlFor="email">{ApplicantRegistrationT('registration.email')}*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.emailPlaceholder')}
                    disabled={isLoading}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                <div className={`form-group ${errors.mobile ? 'error' : ''}`}>
                  <label htmlFor="mobile">{ApplicantRegistrationT('registration.mobile')}*</label>
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.mobilePlaceholder')}
                    maxLength="10"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    disabled={isLoading}
                  />
                  {errors.mobile && <span className="error-message">{errors.mobile}</span>}
                </div>
              </div>
            </div>

            {/* Address Information Section */}
            <div className="form-section">
              <h3 className="section-title">{ApplicantRegistrationT('registration.addressInfo')}</h3>
              <div className={`form-group ${errors.address ? 'error' : ''}`}>
                <label htmlFor="address">{ApplicantRegistrationT('registration.address')}*</label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder={ApplicantRegistrationT('registration.addressPlaceholder')}
                  disabled={isLoading}
                ></textarea>
                {errors.address && <span className="error-message">{errors.address}</span>}
              </div>

              <div className="form-row">
                {/* District Dropdown */}
                <div className={`form-group ${errors.district ? 'error' : ''}`}>
                  <label htmlFor="district">{ApplicantRegistrationT('registration.district')}*</label>
                  <select
                    id="district"
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    disabled={isLoading}
                  >
                    <option value="">{ApplicantRegistrationT('registration.selectDistrict')}</option>
                    {districts.map(district => (
                      <option key={district} value={district}>
                        {getTranslatedLocationName('districts', district)}
                      </option>
                    ))}
                  </select>
                  {errors.district && <span className="error-message">{errors.district}</span>}
                </div>

                {/* Taluka Dropdown */}
                <div className={`form-group ${errors.taluka ? 'error' : ''}`}>
                  <label htmlFor="taluka">{ApplicantRegistrationT('registration.taluka')}*</label>
                  <select
                    id="taluka"
                    name="taluka"
                    value={formData.taluka}
                    onChange={handleChange}
                    disabled={isLoading || !formData.district}
                  >
                    <option value="">{ApplicantRegistrationT('registration.selectTaluka')}</option>
                    {talukas.map(taluka => (
                      <option key={taluka} value={taluka}>
                        {getTranslatedLocationName('talukas', taluka)}
                      </option>
                    ))}
                  </select>
                  {errors.taluka && <span className="error-message">{errors.taluka}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group ${errors.village ? 'error' : ''}`}>
                  <label htmlFor="village">{ApplicantRegistrationT('registration.village')}*</label>
                  <input
                    type="text"
                    id="village"
                    name="village"
                    value={formData.village}
                    onChange={handleChange}
                    placeholder={ApplicantRegistrationT('registration.villagePlaceholder')}
                    disabled={isLoading}
                  />
                  {errors.village && <span className="error-message">{errors.village}</span>}
                </div>
              </div>
            </div>

            {/* Security Section */}
            <div className="form-section">
              <h3 className="section-title">{ApplicantRegistrationT('registration.security')}</h3>
              <div className={`form-group ${errors.password ? 'error' : ''}`}>
                <label htmlFor="password">{ApplicantRegistrationT('registration.password')}*</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder={ApplicantRegistrationT('registration.passwordPlaceholder')}
                  disabled={isLoading}
                />
                <div className="password-strength">
                  <div className={`strength-bar ${passwordStrength < 2 ? 'strength-weak' :
                    passwordStrength < 4 ? 'strength-medium' : 'strength-strong'
                    }`}></div>
                </div>
                {errors.password && <span className="error-message">{errors.password}</span>}
                <small style={{ display: 'block', marginTop: '0.25rem', color: '#666' }}>
                  {ApplicantRegistrationT('registration.passwordRequirements')}
                </small>
              </div>

              <div className={`form-group ${errors.confirmPassword ? 'error' : ''}`}>
                <label htmlFor="confirmPassword">{ApplicantRegistrationT('registration.confirmPassword')}*</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder={ApplicantRegistrationT('registration.confirmPasswordPlaceholder')}
                  disabled={isLoading}
                />
                {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
              </div>

              {/* reCAPTCHA Widget */}
              <ReCAPTCHA
                sitekey='6LfYwAsrAAAAAKwbAzAomjZoUhEXXx3EDBmIqyht'
                onChange={handleCaptchaChange}
              />

            </div>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <button
              type="submit"
              className={`submit-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  {ApplicantRegistrationT('registration.registering')}
                </>
              ) : (
                ApplicantRegistrationT('registration.registerButton')
              )}
            </button>
            <button
              type="button"
              className="reset-button"
              onClick={handleReset}
              disabled={isLoading}
            >
              {ApplicantRegistrationT('registration.resetButton')}
            </button>
          </div>

          <div className="auth-links" style={{ marginTop: '1rem' }}>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>
              {ApplicantRegistrationT('registration.haveAccount')}{' '}
              <a
                href="#login"
                onClick={(e) => {
                  e.preventDefault();
                  onSwitchToLogin();
                }}
                style={{ color: 'var(--primary-color)' }}
              >
                {ApplicantRegistrationT('registration.signIn')}
              </a>
            </p>
          </div>
        </form>
      </div>
      {showInstructions && (
        <div className="instructions-modal-overlay" onClick={() => setShowInstructions(false)}>
          <div className="instructions-modal" onClick={(e) => e.stopPropagation()}>
            <div className="instructions-modal-header">
              <h3>{ApplicantRegistrationT('registration.instructionsTitle')}</h3>
              <button
                className="close-button"
                onClick={() => setShowInstructions(false)}
                aria-label={ApplicantRegistrationT('registration.closeInstructions')}
              >
                ×
              </button>
            </div>
            <div className="instructions-modal-content">
              <p>{ApplicantRegistrationT('registration.instruction1')}</p>
              <p>{ApplicantRegistrationT('registration.instruction2')}</p>
              <p>{ApplicantRegistrationT('registration.instruction3')}</p>
              <p>{ApplicantRegistrationT('registration.instruction4')}</p>
            </div>
            <div className="instructions-modal-footer">
              <button
                className="submit-button"
                onClick={() => setShowInstructions(false)}
              >
                {ApplicantRegistrationT('registration.okButton')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Registration;